<script setup lang="ts">
import type { PortableTextBlock, Image } from '@sanity/types';
import { computed, type Component } from 'vue';


const props = defineProps<{
  block?: {
    _type: string,
    _key: string
    people: Array<{
      title: string;
      jobTitle: string;
      image: Image
    }>;
  },
  config: {
    innerComponent?: Component
  },
}>();

const data = computed(() => ({
  people: props.block?.people,
}));

</script>

<template>
  <component :is="props.config?.innerComponent" v-bind="data"/>
</template>
